import { Col, Row } from 'antd';
import DonorDashboard from 'modules/dashboard/components/DonorDashboard';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const DonorDashboardPage: FC = () => {
  const { t } = useTranslation('dashboard.DashboardPage');

  return (
    <ProfileSideMenuWrapper title={t('donorDashboard')}>
      <Row gutter={[10, 10]} justify="space-between">
        <Col span={24}>
          <DonorDashboard />
        </Col>
      </Row>
    </ProfileSideMenuWrapper>
  );
};

export default DonorDashboardPage;
